var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 9.9987V7.9987H6.66667V8.66536H9.33333V7.9987H10.6667V9.9987H5.33333ZM12.6667 6.66536H3.33333V11.9987H12.6667V6.66536ZM14 5.9987V13.332H2V5.9987L3.33333 3.33203H12.6667L14 5.9987ZM12.176 5.33203H3.82405L4.15738 4.66536H11.8426L12.176 5.33203Z",
    fill: "#4D4E65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/Archive.cf7edda25112cbd2ac99da99425a4a52.svg";
export { ForwardRef as ReactComponent };